import script from "./SpecialAnnouncement.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpecialAnnouncement.vue?vue&type=script&setup=true&lang=ts"

import "./SpecialAnnouncement.vue?vue&type=style&index=0&id=52b61d07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b61d07"]])

export default __exports__